// Snooze dates: presets, the day they end on, and whether one is in force.

export const PRESETS: { label: string; days: number }[] = [
  { label: "1 week", days: 7 },
  { label: "1 month", days: 30 },
  { label: "3 months", days: 90 },
];

// "Pursue & snooze" starts on a week.
export const DEFAULT_SNOOZE_DAYS = 7;

// Snoozes end at 08:00 local time on their day.
export function inDays(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() + days);
  d.setHours(8, 0, 0, 0);
  return d.toISOString();
}

/** A date input's "YYYY-MM-DD" as 08:00 local that day (`new Date(value)` would read UTC). */
export function morningOf(value: string): string {
  const [y, m, d] = value.split("-").map(Number);
  return new Date(y, m - 1, d, 8).toISOString();
}

/** The day `days` from today as a date input's "YYYY-MM-DD", in local time. */
export function dateInputInDays(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() + days);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Tomorrow as "YYYY-MM-DD" in local time: the earliest day a snooze can end. */
export function tomorrowInput(): string {
  return dateInputInDays(1);
}

/** Whether it is snoozed right now (its date is still ahead). */
export function isSnoozed(until: string | null | undefined): boolean {
  return !!until && new Date(until).getTime() > Date.now();
}

/** Whether the snooze is over and no one has decided on it since. */
export function isBackFromSnooze(until: string | null | undefined): boolean {
  return !!until && !isSnoozed(until);
}
